import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/markqueue-orthopedic-section.js';

const items = [
  {
    icon: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0aa2e4d4acd54fd1b4306.png?w=200',
    text: 'Free Shipping - Free Returns - Free Exchanges',
  },
  {
    icon: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0aa2e4d4acd54fd1b4306.png?w=200',
    text: 'Free Shipping - Free Returns - Free Exchanges',
  },
  {
    icon: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0aa2e4d4acd54fd1b4306.png?w=200',
    text: 'Free Shipping - Free Returns - Free Exchanges',
  },
];

const itemsHtml = items
  .map(
    item => `
  <div data-attribute="item-markqueue" class="item-markqueue">
    <div class="icon-item">
      <img data-attribute="icon-item-markqueue" src="${item.icon}" alt="" />
    </div>
    <div data-attribute="text-item-markqueue" class="text-item">
      ${item.text}
    </div>
  </div>
`,
  )
  .join('');

const html = `
<style>${css}</style>
<div
  class="container-markqueue"
  data-attribute="container-markqueue"
  data-background-markqueue="#006196"
  data-text-color-markqueue="#ffffff"
>
  <div data-attribute="block-markqueue" class="block-markqueue">
    ${itemsHtml}
  </div>
</div>
`;
export default containerFuild(html, css, {
  topPadding: true,
  bottomPadding: true,
  textColor: '#ffffff',
});
